/**
 * @generated SignedSource<<695cfaedf6c5f534f5113345b82febf7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MarkupType = "FIXED" | "STANDARD";
export type PackageStatus = "DRAFT" | "EXPIRED" | "PUBLISHED" | "WAITING";
import { FragmentRefs } from "relay-runtime";
export type PackageEditMain_package$data = {
  readonly alreadyPurchased: number | null;
  readonly categories: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly city: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly descriptionText: string | null;
  readonly descriptionTitle: string | null;
  readonly documents: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly excluded: ReadonlyArray<{
    readonly icon: string | null;
    readonly id: string;
    readonly name: string;
  }>;
  readonly id: string;
  readonly included: ReadonlyArray<{
    readonly icon: string | null;
    readonly id: string;
    readonly name: string;
  }>;
  readonly individualAdvance: number | null;
  readonly labels: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly markupType: MarkupType | null;
  readonly markupValueAdult: number | null;
  readonly markupValueChild: number | null;
  readonly name: string;
  readonly notesText: string | null;
  readonly notesTitle: string | null;
  readonly organiser: string | null;
  readonly remainingPaymentDeadlineDays: number | null;
  readonly status: PackageStatus;
  readonly subtitle: string | null;
  readonly validBeforeTripStartDays: number | null;
  readonly whatToSee: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly " $fragmentType": "PackageEditMain_package";
};
export type PackageEditMain_package$key = {
  readonly " $data"?: PackageEditMain_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditMain_package">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
],
v3 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "icon",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditMain_package",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "markupType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "markupValueAdult",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "markupValueChild",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "validBeforeTripStartDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingPaymentDeadlineDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "individualAdvance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alreadyPurchased",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "descriptionTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "descriptionText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notesTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notesText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organiser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "City",
      "kind": "LinkedField",
      "name": "city",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Category",
      "kind": "LinkedField",
      "name": "categories",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Label",
      "kind": "LinkedField",
      "name": "labels",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WhatToSee",
      "kind": "LinkedField",
      "name": "whatToSee",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Term",
      "kind": "LinkedField",
      "name": "included",
      "plural": true,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Term",
      "kind": "LinkedField",
      "name": "excluded",
      "plural": true,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TravelDocument",
      "kind": "LinkedField",
      "name": "documents",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": null
};
})();

(node as any).hash = "e2c6879b5bf7d94ac52190cf53a48336";

export default node;
